import { showMessage } from '../../features/messaging/messaging.slice';
import { AppStore } from '../store';

class MessagingService {
    private rxStore!: AppStore;

    public set store(store: AppStore) {
        this.rxStore = store;
    }

    public showError(message: string) {
        this.rxStore.dispatch(showMessage({ type: 'error', message }));
    }

    public showInfo(message: string) {
        this.rxStore.dispatch(showMessage({ type: 'info', message }));
    }

    public showSuccess(message: string) {
        this.rxStore.dispatch(showMessage({ type: 'success', message }));
    }
}

export const messagingService = new MessagingService();
